import DepsService from 'services/dependencies';
import appHelpers from 'app/app-helpers';

const CONTEXT = 'admin-reports';

export const downloadActivityReports = ({ extension, ...params }) => {
  const { url } = DepsService.rest.report.activity;
  const urlParams = {};
  const headers = appHelpers.setHeader(extension);

  return DepsService.restSrv.downloadBlob(CONTEXT, url, params, urlParams, headers);
};

export const fetchActivityReport = async (queryParams) => {
  const { url } = DepsService.rest.report.activity;
  const urlParams = {};

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/admin-reports/resources/admin-reports.api.js